// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article-header a span[data-v-62542bb2]{cursor:pointer}.article-header__comments-count[data-v-62542bb2]{-webkit-text-decoration:underline!important;text-decoration:underline!important}.article-header__font-smaller[data-v-62542bb2]{font-size:smaller}.article-header__content-tag-font[data-v-62542bb2]{font-size:14px}.article-header__peer-review-notice[data-v-62542bb2]{color:#272727;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
